/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconLetterV = createReactComponent("outline", "letter-v", "IconLetterV", [["path", { "d": "M6 4l6 16l6 -16", "key": "svg-0" }]]);

export { IconLetterV as default };
//# sourceMappingURL=IconLetterV.mjs.map
